import axios from 'axios';
import { getToken } from './loginVerification';

export const saveOpeningHours = async (mode, staticHours, dynamicDates, season, currentStatus) => {
    const tokenData = await getToken();
    let data;
    if (tokenData.ok) {
        const instance = axios.create({
            headers: { 'Authorization': 'Bearer ' + tokenData.token }
        });
        await instance.post(`${process.env.REACT_APP_API_HOST}/openinghours/`, {
            mode: mode,
            staticHours: staticHours,
            dynamicDates: dynamicDates,
            season: season,
            currentStatus: currentStatus
        }).then(resp => {
            data = resp.data;
        });
    }
    return data;
};

